export default __webpack_public_path__ + "static/media/farming-simulator.cc987a75.webp";